/** Albanian display labels for enum values. UI copy lives in apps/web/src/i18n. */
export const ROLE_LABELS = {
    SUPER_ADMIN: 'Administrator',
    LEADERSHIP: 'Drejtues',
    MP_EXECUTIVE: 'Deputet ose anëtar i Kryesisë',
    BRANCH_CHAIR: 'Kryetar dege',
};
export const ACTIVITY_STATUS_LABELS = {
    DRAFT: 'Skicë',
    PUBLISHED: 'I publikuar',
    CANCELLED: 'I anuluar',
};
export const ACTIVITY_STAGE_LABELS = {
    DRAFT: 'Skicë',
    PLANNED: 'I planifikuar',
    AWAITING_REPORT: 'Në pritje të raportimit',
    REALISED: 'I realizuar',
    CANCELLED: 'I anuluar',
};
export const USER_GROUP_LABELS = {
    ELECTED: 'Të zgjedhurit në institucione',
    FIELD: 'Përfaqësuesit në terren',
    CENTRAL: 'Përfaqësuesit qendrorë',
    STAFF: 'Funksionarët e partisë',
    DIASPORA: 'Përfaqësuesit e diasporës',
};
/** Who belongs to each group, shown when the administrator assigns it. */
export const USER_GROUP_HINTS = {
    ELECTED: 'Deputetë, kryetarë bashkie, këshilltarë bashkiakë dhe qarkorë',
    FIELD: 'Kryetarë degësh, sekretarë politikë dhe organizativë, kryetarë seksionesh',
    CENTRAL: 'Anëtarë të Kryesisë, sekretarë, anëtarë të Këshillit Kombëtar, drejtues departamentesh',
    STAFF: 'Stafi i selisë dhe strukturat e organizimit',
    DIASPORA: 'Përfaqësuesit e partisë jashtë vendit',
};
export const UNIT_TYPE_LABELS = {
    BRANCH: 'Degë',
    ADMINISTRATIVE_UNIT: 'Njësi administrative',
};
//# sourceMappingURL=labels.js.map